import { useState, useEffect, useCallback } from 'react';
import { UnitOfMeasureLookupItem } from '../types/costwand';
import { apiClient, ApiError } from '../api/apiClient.ts';

interface UseUnitOfMeasureLookupResult {
  unitsOfMeasure: UnitOfMeasureLookupItem[];
  loading: boolean;
  error: string | null;
  fetchUnitsOfMeasure: () => Promise<void>;
}

export const useUnitOfMeasureLookup = (): UseUnitOfMeasureLookupResult => {
  const [unitsOfMeasure, setUnitsOfMeasure] = useState<UnitOfMeasureLookupItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchUnitsOfMeasure = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      // Changed to use allPages: true and expect { data: T[] }
      const response = await apiClient<{ data: UnitOfMeasureLookupItem[] }>('/units_of_measure', { allPages: true });
      setUnitsOfMeasure(response.data);
    } catch (err) {
      if (err instanceof ApiError) {
        setError(`Failed to fetch units of measure: ${err.message}`);
      } else {
        setError('An unknown error occurred while fetching units of measure.');
      }
      setUnitsOfMeasure([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUnitsOfMeasure();
  }, [fetchUnitsOfMeasure]);

  return {
    unitsOfMeasure,
    loading,
    error,
    fetchUnitsOfMeasure,
  };
};